import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function StVincentJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="St. Vincent & the Grenadines (SVG) as a Jurisdiction"
                subtitle="A Popular Hub for Forex, Brokerage & Offshore Businesses"
                description="St. Vincent & the Grenadines (SVG) is a Caribbean jurisdiction that has become one of the most widely used offshore centers for forex, brokerage, and online trading firms. Unlike Tier-1 regulators (CySEC, FCA, ASIC), SVG offers a low-barrier, cost-effective setup, making it attractive to startups, high-risk operators, and global trading platforms."
                badges={[
                    "Forex & Brokerage",
                    "IBCs",
                    "Offshore Companies",
                    "Flexible Structures"
                ]}
                buttonText="Request a St. Vincent Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/western-sahara-hero.png')}
                imageAlt="St. Vincent & the Grenadines Offshore Jurisdiction"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose SVG?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "🌍 Fast Incorporation",
                                        text: "IBCs formed in 1–2 weeks."
                                    },
                                    {
                                        title: "⚖️ Minimal Regulation",
                                        text: "No heavy capital or compliance requirements."
                                    },
                                    {
                                        title: "💼 Low Costs",
                                        text: "Cheaper than Mauritius, Malta, or Cyprus."
                                    },
                                    {
                                        title: "📊 Popular with Brokers",
                                        text: "Widely used in the forex industry."
                                    },
                                    {
                                        title: "🚀 Privacy & Flexibility",
                                        text: "Light disclosure rules."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Features of SVG"
                        blocks={[
                            {
                                title: "International Business Companies (IBCs)",
                                items: [{ text: "Widely used for brokerage and fintech." }]
                            },
                            {
                                title: "No Forex Regulator",
                                items: [{ text: "Forex/brokerage firms operate under IBC law, not a financial authority." }]
                            },
                            {
                                title: "Low Tax Jurisdiction",
                                items: [{ text: "No local tax on offshore income." }]
                            },
                            {
                                title: "Crypto-Friendly",
                                items: [{ text: "IBCs can run crypto exchanges and PSP models." }]
                            },
                            {
                                title: "Banking & PSP Access",
                                items: [{ text: "Often paired with offshore banking in other jurisdictions." }]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Licenses & Structures in SVG"
                        blocks={[
                            {
                                title: "Forex & Brokerage Companies",
                                items: [
                                    { text: "Operate as IBCs, offering brokerage, trading, and clearing." },
                                    { text: "No direct oversight, but widely accepted in high-risk markets." }
                                ]
                            },
                            {
                                title: "Crypto & PSP Operators",
                                items: [
                                    { text: "SVG IBCs used for crypto exchanges, wallets, and PSP services." },
                                    { text: "Must establish AML/KYC frameworks for credibility." }
                                ]
                            },
                            {
                                title: "General IBCs",
                                items: [
                                    { text: "For international trade, holding, and structuring." },
                                    { text: "Low-cost, fast-track setup." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={[
                            {
                                title: "Capital Requirements",
                                text: "None."
                            },
                            {
                                title: "Entity",
                                text: "SVG IBC."
                            },
                            {
                                title: "Resident Presence",
                                text: "Not required."
                            },
                            {
                                title: "Compliance",
                                text: "AML/KYC suggested but not enforced by regulator."
                            },
                            {
                                title: "Banking",
                                text: "Offshore banking needed outside SVG."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of SVG'
                        services={[
                            {
                                title: "🌍 Fast & Simple",
                                text: "IBCs ready in 1–2 weeks."
                            },
                            {
                                title: "⚖️ Low Cost",
                                text: "Among the cheapest in the Caribbean."
                            },
                            {
                                title: "💳 Flexible Use",
                                text: "Brokerage, fintech, crypto, or holding."
                            },
                            {
                                title: "📈 Privacy",
                                text: "Minimal reporting obligations."
                            },
                            {
                                title: "🚀 Starter-Friendly",
                                text: "Used by thousands of forex firms."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Limitations of SVG'
                        features={[
                            {
                                title: "❌ No Tier-1 Recognition",
                                text: "Not respected like Cyprus, Malta, or Mauritius."
                            },
                            {
                                title: "❌ Banking Challenges",
                                text: "Many banks refuse SVG brokers."
                            },
                            {
                                title: "❌ No Investor Protection",
                                text: "Clients are not protected by a regulator."
                            },
                            {
                                title: "❌ High-Risk Perception",
                                text: "Often blacklisted by payment providers."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={[
                            {
                                text: "We help structure SVG IBCs with proper AML/KYC for credibility."
                            },
                            {
                                text: "Integration with banking, PSPs, and payment solutions."
                            },
                            {
                                text: "Comparative analysis: SVG vs Seychelles vs Mauritius vs Cyprus."
                            },
                            {
                                text: "Guidance on upgrading from SVG to Tier-1 licenses (e.g., Cyprus, Malta)."
                            },
                            {
                                text: "End-to-end support for brokerage & crypto operators."
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a fast, low-cost entry point into forex, crypto, or offshore business?"
                        description="St. Vincent offers IBC structures and brokerage-friendly incorporation, ideal for startups and high-risk operators."
                        buttonText="Book a St. Vincent Company Setup Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Does SVG issue forex licenses?",
        answer: "No — forex brokers operate under IBCs without direct regulation."
    },
    {
        question: "Why do brokers still choose SVG?",
        answer: "Fast setup, low costs, and flexibility."
    },
    {
        question: "Is SVG credible for institutional clients?",
        answer: "No — Tier-1 licenses (CySEC, FCA, ASIC) are needed for institutional credibility."
    },
    {
        question: "Can SVG companies run crypto exchanges?",
        answer: "Yes — but banking/PSP solutions must be arranged offshore."
    },
    {
        question: "How fast is incorporation?",
        answer: "1–2 weeks."
    }
];

const testimonialsData = [
    {
        quote: "We launched our forex brokerage via an SVG IBC. Offshore Advisory handled incorporation and PSP integration.",
        author: "Alex R.",
        role: "Broker CEO"
    },
    {
        quote: "SVG was our entry point. Offshore Advisory later guided us to upgrade to a CySEC license.",
        author: "Marina T.",
        role: "Trading Firm Founder"
    }
];
